import React, { Component } from 'react';
import { connect } from 'react-redux';
import { smsCreationPending, fireSmsValidation, fireSmsCreation } from '../../../../reducers/auth'
import { geti18n } from '../../../../reducers/i18n';
import { clearSms } from '../../../../reducers/sendSmsStatus'
import { isSmsChecking, isSmsCreated, checkSmsPending, isLoggedIn, didSmsCreationFailed } from '../../../../reducers/auth';
import { getUserDetails, didUserDetailsSuccess, didUserDetailsFailed, isUserDetailsPending } from '../../../../reducers/userDetails';
import { getDealInfo, isDealInfoLoaded, isDealInfoPending, didDealInfoFailed } from '../../../../reducers/DealInfo';
import { trackEvent, EVENTS } from '../../../../tracking/tracking';
import { RegularError, SmallError } from '../../../InputError';
import Button from '../../../Button';
import Title from '../../../Title';
import Spinner from '../../../Spinner';
import P from 'prop-types';

class SmsStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: this.props.summary.get('phoneNumber', ''),
      name: this.props.summary.get('firstName', ''),
      invalidSmsCode: null,
      smsCode:''
    };
    this.props.clearSms();
    // this.props.clearUserDetails();
    this.continue = this.continue.bind(this);
    this.captureInputs = this.captureInputs.bind(this);
    this.getValidationError = this.getValidationError.bind(this);
  }

  componentDidUpdate() {
    if (this.props.isLoggedIn && this.props.didUserDetailsSuccess && this.props.isDealInfoLoaded) {
      // this.props.next();
        if(this.props.dealInfo.get("signatureRequestCreated")){
          this.props.jump(6);
          // this.props.next();
        }else{
          this.props.next();
        }
    }
  }

  getValidationError(value, regexFormat, regexEmpty, errorFormat, errorEmpty){
    if(regexEmpty.test(value)){
      return errorEmpty;
    }
    else if(!regexFormat.test(value)){
      return errorFormat;
    }
    else{
      return null;
    }
  }

  continue(event) {
    trackEvent(EVENTS.ENTER_PHONE_CLICKED, { phoneNumber: this.state.phoneNumber });
    event.preventDefault();
    this.setState({ completed: true });
    const i18n = this.props.i18n;
    const phoneValidation = /^((\d|-|\+)+)$/;
    const emptyValidation = /^$/;
    const invalidSmsCode = this.getValidationError(
      this.state.smsCode, phoneValidation, emptyValidation,
      i18n('onboarding.smsValidation.insertCodeTextError'),
      i18n('onboarding.smsValidation.invalidEmpty')
    );
    this.setState({
      invalidSmsCode
    })

    if (phoneValidation.test(this.state.smsCode)) {
      this.props.fireSmsValidation(this.state.phoneNumber, this.state.smsCode);
    } else {
      console.log('Something is wrong');
    }
  }
  captureInputs(event) {
    const target = event.target;
    const val = event.target.value;
    const name = target.name;
    this.setState({
      [name]: val,
      invalidSmsCode: null,
    });
    if(this.props.didUserDetailsFailed){
      // this.props.clearUserDetails();
      this.props.clearSms();
    }
  }

  render() {
    const i18n = this.props.i18n;
    const error = this.state.invalidSmsCode ? <SmallError message={i18n('onboarding.smsValidation.insertCodeText')}/>: null;
    const errorSmsCode = (this.props.didSmsCreationFailed || this.props.didDealInfoFailed)  ? <RegularError message={i18n('onboarding.smsValidation.invalidCode')}/> : null;
    const loading = this.props.isSmsChecking || this.props.isUserDetailsPending || this.props.isDealInfoPending  ? <Spinner/> : null
    return (
      <div className="text-center">
        <div className="row justify-content-center">
          <div className="col-8 col-sm-0">
            <Title text={i18n('onboarding.phoneStep.welcome')} className="form__title" />
          </div>
        </div>

        <div className="row justify-content-center mb-5 pb-sm-4">
          <div className="col-10 col-sm-7 px-sm-4">
            <p className="form__description mb-0">{i18n('onboarding.phoneStep.text1')}</p>
          </div>
        </div>
        <div className="row justify-content-center mb-5 mb-sm-0">
          <div className="col-8 col-sm-3 px-sm-4">
            <p className="form__description px-2 px-sm-0 font-weight-bold">{i18n('onboarding.smsValidation.insertCodeText')}</p>
          </div>
        </div>
        <form onSubmit={this.continue} className="form">
          <fieldset className="mb-4 pb-sm-3">
            <input
              name="smsCode"
              className={`form__input ${errorSmsCode || error ? 'form__input--error' : ''}`}
              type="tel"
              onChange={this.captureInputs}
              // value={this.state.smsCode}
              placeholder={i18n('onboarding.smsValidation.codePlaceholder')}
            />
            {errorSmsCode}
            {error}
          </fieldset>
          <label className="d-block form__link px-2 px-sm-0 mb-5 mb-sm-5" htmlFor="privacyPolicy">
          <button className="btn btn-link" onClick={()=>this.props.fireSmsCreation(this.state.phoneNumber)} type="button">
            {i18n('onboarding.smsValidation.sendAgainText')}{" "}
            <span className="font-weight-bold">{i18n('onboarding.smsValidation.sendAgainText2')}</span>
          </button>
          </label>
          <Button text={i18n('onboarding.smsValidation.buttonText')} onClick={this.continue} />
        </form>
        {loading}
      </div>
    );
  }
}


SmsStep.propTypes = {
  i18n: P.func,
  isSmsChecking: P.bool,
  isUserDetailsPending: P.bool,
  didUserDetailsFailed: P.bool
}

const mapStateToProps = state => ({
  userDetailss: state.userDetails,
  userDetails: getUserDetails(state),
  isUserDetailsPending: isUserDetailsPending(state),
  didUserDetailsFailed: didUserDetailsFailed(state),
  didUserDetailsSuccess: didUserDetailsSuccess(state),
  contracts: state.sendContracts,
  isSmsChecking: isSmsChecking(state),
  isSmsCreated: isSmsCreated(state),
  didSmsCreationFailed: didSmsCreationFailed(state),
  isLoggedIn: isLoggedIn(state),
  dealInfo: getDealInfo(state),
  isDealInfoLoaded: isDealInfoLoaded(state),
  isDealInfoPending: isDealInfoPending(state),
  didDealInfoFailed: didDealInfoFailed(state),
  i18n: geti18n(state)
});

const actionMakers = {
  fireSmsValidation,
  fireSmsCreation,
  smsCreationPending,
  clearSms,
  checkSmsPending
}

export default connect(mapStateToProps, actionMakers)(SmsStep);



// WEBPACK FOOTER //
// ./src/components/Views/Onboarding/Steps/SmsStep.js